export enum ENetWork {
  BEP20 = "BEP20",
  TRC20 = "TRC20",
}

export interface IRequestWithdrawPayload {
  coinId: number
  feeCoinId: number
  value: number
}

export enum EActionType {
  APPROVE = 'approve',
  REJECT = 'reject',
}

export enum ERunWithdrawForAdminStatus {
  START = "START",
  DOING_TRANFER_FEE = "DOING_TRANFER_FEE",
  DONE_TRANFER_FEE = "DONE_TRANFER_FEE",
  DOING_WITHDRAW = "DOING_WITHDRAW",
  DONE_WITHDRAW = "DONE_WITHDRAW",
  ERROR = "ERROR",
}

export enum ERunWithdrawForAdminLabel {
  START = "Start withdraw to admin wallet",
  REPAIRE = "Repaire withdraw to admin wallet",
  DOING_TRANFER_FEE = "Doing transfer fee",
  DONE_TRANFER_FEE = "Done transfer fee",
  DOING_WITHDRAW = "Doing withdraw",
}
